import { ref } from 'vue';

import {
  NullableQueryNumber,
  QueryBooleanOrArray,
  QueryNumber,
  QueryString,
  QueryStringOrArray,
  Sanitizer,
} from 'SharedDir/common/composables/useQueryString';
import { BasePaginated, BasePagination, PaginationParams } from 'SharedDir/declarations/pagination';

// todo: добавить типы этому всему !!!!!!!!!!!
export const paginator = (extra: Record<string, Sanitizer> = {}) => ({
  page: QueryNumber,
  rowsPerPage: NullableQueryNumber,
  sortBy: QueryStringOrArray,
  descending: QueryBooleanOrArray,
  ...extra,
});

export const blankPaginator = <T extends Record<string, unknown>>(
  extra: T = {} as T
): PaginationParams<T> => ({
  page: 1,
  rowsPerPage: 25,
  rowsNumber: 0,
  sortBy: 'id',
  descending: false,
  ...extra,
});

export function usePagination(extraPaginationParams: BasePagination | {} = {}) {
  const defaultPaginator = blankPaginator;

  const paginationParams = ref<BasePaginated>({ ...defaultPaginator(), ...extraPaginationParams });

  const sanitizeQueryPagination = paginator;

  const setPaginationFromData = (responseData) => {
    paginationParams.value.page = responseData.page ?? paginationParams.value.page;

    paginationParams.value.rowsPerPage =
      responseData.rowsPerPage ?? paginationParams.value.rowsPerPage;

    paginationParams.value.descending =
      responseData.descending ?? paginationParams.value.descending;

    paginationParams.value.sortBy = responseData.sortBy ?? paginationParams.value.sortBy;

    paginationParams.value.rowsNumber =
      responseData.rowsNumber ?? paginationParams.value.rowsNumber;
  };

  /**
   * Сброс пагианции к заводским настройкам
   */
  function resetPagination() {
    paginationParams.value = <BasePaginated>defaultPaginator(extraPaginationParams);
  }

  return {
    paginationParams,
    sanitizeQueryPagination,
    setPaginationFromData,
    defaultPaginator,
    resetPagination,
  };
}
